import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-45525072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "at-logo-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "at-logo-card__logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "at-logo-card__logo",
    src: _imports_0,
    alt: "Logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "at-logo-card__app-name" }, "Smart Search", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "at-logo-card__subtitle" }, "Author.Today", -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}